import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Form, PolicyCheckFields, useForm } from "@jti/ui";
export const PolicyCheckFieldsWrapper = ({ setIsPolicyRead, ...restProps }) => {
    const form = useForm({
        reValidateMode: "onChange",
        defaultValues: {
            isPolicyRead: false,
        },
        shouldUnregister: false,
    });
    const { watch } = form;
    const isPolicyRead = watch("isPolicyRead");
    useEffect(() => {
        setIsPolicyRead(isPolicyRead);
    }, [setIsPolicyRead, isPolicyRead]);
    return (_jsx("div", { ...restProps, children: _jsx(Form, { form: form, dataTestId: "policyCheckFieldsWrapper", children: _jsx(PolicyCheckFields, {}) }) }));
};
//# sourceMappingURL=PolicyCheckFieldsWrapper.js.map